import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Container,
    Card,
    CardMedia,
    CircularProgress,
    List,
    ListItem,
    Grid,
} from "@mui/material";

function Telecommunications() {
    const [telecommunication, setTelecommunication] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get("/files/industries/telecommunication.txt")
            .then((res) => {
                setTelecommunication(res.data);
                setLoading(false);
            })
            .catch((err) => console.error("Error fetching data:", err));
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            {/* Title */}
            <Typography
                variant="h3"
                align="center"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: "#030366",
                    mt: 7,
                    fontSize: {
                        xs: "1.8rem",  // mobile (~h4)
                        sm: "2.2rem",  // tablet (~h3)
                        md: "2.8rem",  // laptop (~h3+)
                        lg: "3rem",    // desktop (~h2)
                    },
                }}
            >
                Telecommunication
            </Typography>

            {loading ? (
                <Box display="flex" justifyContent="center" mt={4}>
                    <CircularProgress color="secondary" />
                </Box>
            ) : (
                <Grid
                    container
                    spacing={4}
                    alignItems="flex-start"
                    sx={{
                        flexDirection: {
                            xs: "column", // Mobile
                            sm: "column", // Tablet
                            md: "row", // Laptop & Desktop remain same
                        },
                    }}
                >
                    {/* Text Content */}
                    <Grid
                        item
                        xs={12}
                        md={7}
                        sx={{
                            width: { xs: "100%", md: "60%" },
                            order: { xs: 1, md: 1 }, // content first on mobile & desktop
                        }}
                    >
                        {telecommunication &&
                            telecommunication.map((data, index) => (
                                <Box key={index} mb={3}>
                                    {Array.isArray(data) ? (
                                        <>
                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    fontWeight: 600,
                                                    color: "#030366",
                                                    mb: 1,
                                                }}
                                            >
                                                VENSYX Data Solutions Provides:
                                            </Typography>
                                            <List sx={{ pl: 3 }}>
                                                {data.map((subItem, subIndex) => (
                                                    <ListItem
                                                        key={subIndex}
                                                        sx={{
                                                            display: "list-item",
                                                            listStyleType: "disc",
                                                            pl: 1,
                                                            fontSize: "16px",
                                                        }}
                                                    >
                                                        {subItem}
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </>
                                    ) : (
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                mb: 2,
                                                textAlign: "justify",
                                                fontSize: "18px",
                                            }}
                                        >
                                            {data}
                                        </Typography>
                                    )}
                                </Box>
                            ))}
                    </Grid>

                    {/* Image Section */}
                    <Grid
                        item
                        xs={12}
                        md={5}
                        sx={{
                            width: { xs: "100%", md: "35%" },
                            order: { xs: 2, md: 2 }, // image below on mobile/tablet
                        }}
                    >
                        <Card
                            sx={{
                                borderRadius: 3,
                                overflow: "hidden",
                                boxShadow: 4,
                                width: "100%",
                            }}
                        >
                            <CardMedia
                                component="img"
                                image="/images/telecommunication1.jpg"
                                alt="Telecommunication"
                                sx={{
                                    width: "100%",
                                    height: { xs: 250, sm: 300, md: 450 },
                                    objectFit: "cover",
                                }}
                            />
                        </Card>
                    </Grid>
                </Grid>
            )}
        </Container>
    );
}

export default Telecommunications;







// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//     Box,
//     Typography,
//     Container,
//     Card,
//     CardContent,
//     CardMedia,
//     CircularProgress,
//     List,
//     ListItem,
//     Grid,
// } from "@mui/material";

// function Telecommunications() {
//     const [telecommunication, setTelecommunication] = useState(null);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         axios({
//             method: "GET",
//             url: "/files/industries/telecommunication.txt",
//         }).then((res) => {
//             setTelecommunication(res.data);
//             setLoading(false);
//         });
//     }, []);

//     return (
//         <Container maxWidth="lg" sx={{ py: 2 }}>
//             {/* Title */}
//             <Typography
//                 variant="h3"
//                 align="center"
//                 gutterBottom
//                 sx={{ fontWeight: "bold", color: "#030366", mt: 7 }}
//             >
//                 Telecommunication
//             </Typography>

//             {loading ? (
//                 <Box display="flex" justifyContent="center" mt={4}>
//                     <CircularProgress color="secondary" />
//                 </Box>
//             ) : (
//                 <Grid container spacing={4} alignItems="flex-start">
//                     {/* Content Section */}
//                     <Grid item xs={12} md={7} sx={{ width: "60%" }}>
//                         {telecommunication &&
//                             telecommunication.map((data, index) => (
//                                 <Box key={index} mb={3}>
//                                     {Array.isArray(data) ? (
//                                         <>
//                                             <Typography
//                                                 variant="h6"
//                                                 sx={{ fontWeight: "600", color: "#030366", mb: 1 }}
//                                             >
//                                                 VENSYX Data Solutions Provides:
//                                             </Typography>
//                                             <List sx={{ pl: 3 }}>
//                                                 {data.map((subItem, subIndex) => (
//                                                     <ListItem
//                                                         key={subIndex}
//                                                         sx={{
//                                                             display: "list-item",
//                                                             listStyleType: "disc",
//                                                             pl: 1,
//                                                             fontSize: "16px",
//                                                         }}
//                                                     >
//                                                         {subItem}
//                                                     </ListItem>
//                                                 ))}
//                                             </List>
//                                         </>
//                                     ) : (
//                                         <Typography
//                                             variant="body1"
//                                             sx={{ mb: 2, textAlign: "justify", fontSize: "18px" }}
//                                         >
//                                             {data}
//                                         </Typography>
//                                     )}
//                                 </Box>
//                             ))}
//                     </Grid>

//                     {/* Image Section */}
//                     <Grid item xs={12} md={5} sx={{ width: "35%" }}>
//                         <Card
//                             sx={{
//                                 borderRadius: 3,
//                                 overflow: "hidden",
//                                 boxShadow: 4,
//                             }}
//                         >
//                             <CardMedia
//                                 component="img"
//                                 image="/images/telecommunication1.jpg"
//                                 alt="Telecommunication"
//                                 sx={{ height: { xs: 250, md: 450 }, objectFit: "cover" }}
//                             />
//                         </Card>
//                     </Grid>
//                 </Grid>
//             )}
//         </Container>
//     );
// }

// export default Telecommunications;
